<template>
  <div class="popup-video" @click.stop="'javascript:void(0)';">
    <div class="popup-title" v-show="videoReady">{{ currenTitle }}</div>
    <div class="popup-desc" v-show="videoReady">{{ currenDesc }}</div>
    <div class="video-wrap" v-show="videoReady">
      <video
        id="video"
        :src="videoUrl"
        autoplay
        muted
        x5-video-player-fullscreen="true"
        x5-video-player-type="h5"
        playsinline="true"
        webkit-playsinline="true"
      ></video>
    </div>
    <img class="close" v-if="isMobileSize" :src="closeIcon" @click="$emit('close')" alt="" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    index: {
      type: Number,
    },
  },
  data() {
    return {
      videoReady: false,
      timer: null,
    };
  },
  computed: {
    ...mapGetters(['isMobileSize']),
    currenTitle() {
      return this.$t(`keypalTwo.introduce.label_${this.index}`);
    },
    currenDesc() {
      return this.$t(`keypalTwo.introduce.label_${this.index}_1`);
    },
    videoUrl() {
      let lang = '';
      if (this.$i18n.locale === 'zh') {
        lang = '-zh';
      }
      if (this.index === 1) {
        return `https://hk.tpstatic.net/keypal-2/01${lang}${this.darkModeImg}.mp4?version=2`;
      } else if (this.index === 3) {
        return `https://hk.tpstatic.net/keypal-2/03${lang}.mp4?version=2`;
      }
      return `https://hk.tpstatic.net/keypal-2/0${this.index}.mp4?version=2`;
    },
    closeIcon() {
      return require(`../../assets/images/keypal-two/close${this.darkModeImg}.png`);
    },
  },
  // watch: {
  //   index(val) {
  //     if (!val) {
  //       this.videoReady = false;
  //       clearTimeout(this.timer);
  //       return;
  //     };
  //     this.videoReady = false;
  //     clearTimeout(this.timer);
  //     this.timer = setTimeout(() => {
  //       this.videoReady = true;
  //     }, 0.5 * 1000);
  //   },
  // },
  mounted() {
    if (this.isMobileSize) {
      this.videoReady = true;
      return;
    }
    this.timer = setTimeout(() => {
      this.videoReady = true;
    }, 0.4 * 1000);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.videoReady = false;
  },
};
</script>

<style lang="scss" scoped>
.popup-video {
  width: 1200px;
  padding: 66px 120px 85px;
  background: var(--bg-2);
  border-radius: 32px;
  word-break: break-word;
  .popup-title {
    color: var(--color-1);
    font-size: 44px;
    text-align: center;
    font-weight: 500;
  }

  .popup-desc {
    margin-top: 16px;
    color: var(--color-3);
    font-size: 20px;
    text-align: center;
  }

  .video-wrap {
    margin-top: 70px;
    font-size: 0;
    video {
      width: 960px;
      height: 400px;
      border-radius: 32px;
    }
  }

  .close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
}

@media screen and (max-width: 1450px) {
  .popup-video {
    font-size: 30px;
    display: flex;
    flex-direction: column;
    padding: 33px 60px 42px;

    .popup-title {
      font-size: 0.8em;
    }

    .popup-desc {
      font-size: 0.8em;
    }

    .video-wrap {
      flex: 1 1;
      min-height: 0;
      height: 100%;
      video {
        width: 100%;
        height: 100%;
        border-radius: 16px;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .popup-video {
    font-size: 30px;
    display: flex;
    flex-direction: column;

    .popup-title {
      font-size: 0.8em;
    }

    .popup-desc {
      font-size: 0.8em;
    }

    .video-wrap {
      flex: 1 1;
      min-height: 0;
      height: 100%;
      video {
        width: 100%;
        height: 100%;
        border-radius: 16px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .popup-video {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0;
    border-radius: 16px 16px 0 0;
    padding: 25px 28px 105px;

    .popup-title {
      font-size: 24px;
      text-align: left;
      padding: 0 30px 0 0;
    }

    .popup-desc {
      margin-top: 10px;
      font-size: 16px;
      text-align: left;
    }

    .video-wrap {
      video {
        width: 100%;
        height: auto;
        border-radius: 16px;
      }
    }
  }
}
</style>
